export default __webpack_public_path__ + "static/media/shape-5.e828fd2d.png";